import { APIResponse, Result, returnAxios } from 'app/shared/util/class-utils';
import { AppError } from 'app/shared/util/error-utils';
import axios, { AxiosResponse } from 'axios';
import { cmsLanguages } from '../tools/types';

export interface ICmsApi {
  getPageContentFromCms(contentType: string): Promise<APIResponse<any>>;
  AppStylesFromCms(): Promise<APIResponse<any>>;
  getMarketingCampaignContentFromCms(): Promise<APIResponse<any>>;
}

export class CmsApi implements ICmsApi {
  async getPageContentFromCms(contentType: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get('cms/page/' + contentType, {
        headers: {
          'Accept-Language': cmsLanguages()
        }
      })
    );
  }

  async AppStylesFromCms(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('cms/app-styles'));
  }

  async getMarketingCampaignContentFromCms(): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get(`cms/marketing/campaign`, {
        headers: {
          'Accept-Language': cmsLanguages()
        }
      })
    );
  }
}
